var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"translate",rawName:"v-translate:dynamic_string",value:({
    key: (_vm.translationKeyInitial + "_formattedBody"),
    val: _vm.lang,
    html: _vm.question.formattedBody
  }),expression:"{\n    key: `${translationKeyInitial}_formattedBody`,\n    val: lang,\n    html: question.formattedBody\n  }",arg:"dynamic_string"}],domProps:{"innerHTML":_vm._s(_vm.question.formattedBody)},on:{"~click":function($event){_vm.$emit('onClick', _vm.question)}}})}
var staticRenderFns = []

export { render, staticRenderFns }